import { z } from "zod";

export const currentUserInfoSchema = z.object({
	email: z.string(),
	firstName: z.string().nullable(),
	lastName: z.string().nullable(),
	mobilePhoneNumber: z.string(),
	roleId: z.number(),
	userId: z.string(),
	role: z.string(),
	rowId: z.number(),
	isMfaEnabled: z.boolean(),
});

export type CurrentUserInfo = z.infer<typeof currentUserInfoSchema>;

export type UpdateWebUserBody = {
	Errors: string;
	Role: string;
	Roles: { Role: string; RoleValue: number };
	email: string;
	firstName: string;
	lastName: string;
	mobilePhoneNumber: string;
	roleId: number;
	rowId: string;
	userId: string;
};
